import reducers from "./languageReducer";
export default reducers;
